import React from 'react'

interface ProductInfoProps {
	product: Record<string, string> | null
	bestBefore?: number | null
	locale: any
	price: number | null
}

const ProductInfo: React.FC<ProductInfoProps> = props => {
	const image = Array.isArray(props.product?.image) ? props.product?.image[0] : props.product?.image

	const imageStyle: React.CSSProperties = {
		backgroundImage: props.product ? `url('https://shop.futurestorearnhem.nl/img/product/${image}')` : '',
	}

	return (
		<div className="grid__col grid__col--10 grid__col--offset-1 grid__col--spacing">
			<div className="product product--border">
				<div className="product__image-placeholder">
					<div className="product__image product__image--background" style={imageStyle} />
				</div>
				<div className="product__info">
					<h2 className="product__name">{
						props.product?.[`summary_${props.locale}`] !== '' ?
							props.product?.[`summary_${props.locale}`] :
							props.product?.summary_nl
					}</h2>
					<div className="product__description" dangerouslySetInnerHTML={{__html:
							(props.product?.[`description_${props.locale}`] !== '' ?
								props.product?.[`description_${props.locale}`] :
								props.product?.description_nl)
							?? ''}} />
					<div className="product__price">
						{props.price?.toLocaleString('nl-NL', {
							style: 'currency',
							currency: 'EUR',
						})}
					</div>
					{(typeof props.bestBefore !== 'undefined' && props.bestBefore !== null && !isNaN(props.bestBefore)) &&  (
						<div className="product__description product__description--italic">
							<p>
								{props.bestBefore === 0
									? 'Vandaag nog goed!'
									: `Nog ${props.bestBefore} ${props.bestBefore > 1 ? 'dagen' : 'dag'} tot de T.H.T. datum!`
								}
							</p>
						</div>
					)}
				</div>
			</div>
		</div>
	)
}

export default ProductInfo
